import React, { Component } from "react";
import { Slide, Fade } from "react-awesome-reveal";


class Skills extends Component {
  constructor(props) {
    super(props);
    this.state = { isRevealed: false };
  }

  handleReveal = () => {
    this.setState({ isRevealed: true });
  };

  renderSkills(skills, type) {
    return skills
      .filter((skill) => skill.type === type)
      .map((skill, i) => (
        <div className="list-inline-item mx-3" key={i}>
          <div className="text-center skills-tile">
            <div className="skill-icon-container">
              <i className={skill.class} style={{ fontSize: "220%" }}></i>
              <p
                className="text-center"
                style={{
                  fontSize: "14px",
                  marginTop: "10px",
                  fontFamily: "Nunito",
                }}
              >
                {skill.name}
              </p>
            </div>
          </div>
        </div>
      ));
  }

  render() {
    if (!this.props.sharedSkills || !this.props.resumeBasicInfo) {
      return null;
    }

    const sectionName = this.props.resumeBasicInfo.section_name.skills;
    const { icons } = this.props.sharedSkills;

    return (
      <section id="skills">
        <div className="col-md-12 skills-container">
          <div className="top-wave yellow-wave">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffe13a"
                fillOpacity="1"
                d="M0,160L80,149.3C160,139,320,117,480,133.3C640,149,800,203,960,218.7C1120,235,1280,213,1360,202.7L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
              ></path>
            </svg>
          </div>
          <Fade
            triggerOnce={true}
            duration={1500}
            direction="up"
            fraction={0.1}
            onVisibilityChange={(inView) => {
              if (inView) this.handleReveal();
            }}
          >
            <div className="col-md-12">
              <div className="section-title" id="skill">
                <h1 className="text-white">{sectionName}</h1>
              </div>
            </div>
          </Fade>
          <Slide triggerOnce={true} duration={1500} direction="left" fraction={0.1}>
            <div className="text-center skills-items-container">
              <div className="skills-item">
                <div className="skill-title">
                  <span>Langages</span>
                </div>
                <div className="skill-icon languages-icon">
                  {this.renderSkills(icons, "language")}
                </div>
              </div>
              <div className="skills-item">
                <div className="skill-title">
                  <span>Outils et Frameworks</span>
                </div>
                <div className="skill-icon tools-icon">
                  {this.renderSkills(icons, "tool")}
                </div>
              </div>
            </div>
          </Slide>
          <div className="bottom-wave yellow-wave">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffe13a"
                fillOpacity="1"
                d="M0,160L80,149.3C160,139,320,117,480,133.3C640,149,800,203,960,218.7C1120,235,1280,213,1360,202.7L1440,192L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>
      </section>
    );
  }
}

export default Skills;
